import React from "react"
import { connect } from "react-redux"
import { Redirect } from "react-router-dom"
import moment from 'moment'
import NumberFormat from "react-number-format"
import cookie from 'react-cookies'
import { Modal } from "react-bootstrap"
import StarRatings from "react-star-ratings"

import { getLoggedProfile } from "../../actions/sessionAct"
import { getOrderInfo } from "../../model/car"

import { commonErr } from "../common/errors"
import { TPlatformType, WDTypes, MiAppType } from "../common/common"
import { LoadingPage } from "../common/loading"
import { initMap } from "../common/wdfunction"


import Header from "../common/header"
import Footer from "../common/footer"
import Sidebar from "../common/sidebar"
import CancelTrip from "./canceltrip"

import marker_0 from "../../static/img/marker-1.png";
import marker_1 from "../../static/img/marker-2.png";
import marker_2 from "../../static/img/marker-3.png";
import marker_3 from "../../static/img/marker-4.png";
import marker_4 from "../../static/img/marker-5.png";

import load from "../../static/img/loading.gif"

class StatusTripBox extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			status: props.status,
			showStatusTrip: false,
			message: ""
		}
	}

	static getDerivedStateFromProps(nextProps, prevState){
		if (nextProps.status !== prevState.status) {
			if (prevState.status === 102) {
				return { status: nextProps.status };
			}
			return null 
	 }
	 else return null;
	}
	
	componentDidUpdate(prevProps, prevState) {
		
		if (prevState.status !== this.state.status) {
			if (this.state.status === 200) {
				this.setState({
					message: "Đã tìm được xe."
				})
			} else if (this.state.status === -740) {
				this.setState({
					message: "Không tìm được xe phù hợp."
				})
			} else if (this.state.status !== 23 && this.state.status !== 24) {
				this.openStatusTrip()
			}
		}
	}

	openStatusTrip = () => {
		this.setState({
			showStatusTrip: true
		})
	}

	hideStatusBox() {
		this.setState({
			showStatusTrip: false
		})
	}

	render() {
		const { showStatusTrip, message } = this.state;
		
		return <Modal
			show={showStatusTrip}
			onHide={this.hideStatusBox.bind(this)}
			dialogClassName="modal-sm modal-dialog">
			<Modal.Header closeButton={true} closeLabel={""}>
				<Modal.Title>Thông báo</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div style={{ textAlign: "center", "padding": "1.5rem 2.5rem" }}>
					<div className="textAlign-center">{message}</div>
				</div>
			</Modal.Body>
		</Modal>
	}
}


class TripDetail extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showLoginForm: false,
			showCancelForm: false,
			showApproveForm: false,
			showRejectForm: false,
			showPickupForm: false,
			showReturnForm: false,
			showCancelOwnerForm: false,
			showTripPhoto: false,
			showMessageUpload: false,
			showInsuranceForm: false,
			showMsgCert: false,
			isShowTravelerReviewForm: false,
			err: commonErr.INNIT,
			errMsg: "",
			carGroup: null,
			order: null,
			profiles: null,
			paymentUrl: "",
			certInfo: null,
			directionsService: null,
			directionsRenderer: null,
			markerArr: [],
		}
		
		this.getOrder = this.getOrder.bind(this);
		this.showLoginForm = this.showLoginForm.bind(this);
		this.closeLoginForm = this.closeLoginForm.bind(this);
		this.getLoggedProfile = this.getLoggedProfile.bind(this);
		this.map = React.createRef()

		// this.buildTravelerTripStatusBar = this.buildTravelerTripStatusBar(this);

		// this.showMessageUpload = this.showMessageUpload.bind(this);
		// this.closeMessageUpload = this.closeMessageUpload.bind(this);

		// this.hideMessageBox = this.hideMessageBox.bind(this);
		// this.getActiveInsurance = this.getActiveInsurance.bind(this);
		// this.onCertDetailBtn = this.onCertDetailBtn.bind(this);
		// this.isEnabledActIns = this.isEnabledActIns.bind(this);

	}



	componentDidMount() {
		window.scrollTo(0, 0);

		const tripId = this.props.match.params.tripId;
		this.getOrder(tripId);

	}


	getOrder(tripId) {
		getOrderInfo(tripId).then(resp => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data) {
			
				this.setState({
					err: resp.data.error,
					carGroup: resp.data.data.order.carGroup,
					order: resp.data.data.order,
					trip: resp.data.data.order.trip,
					travelerInfo: resp.data.data.order.travelerInfo,
					status: resp.data.data.order.status,
					f1Info: resp.data.data.order.f1Info
				});
				
				let status = resp.data.data.order.status;
		
				let refreshStatus;

				if (status === 102) {

					refreshStatus = setTimeout(() => {

					 this.getOrder(tripId);

					}, 30000);	

				} else if (status === 200) {
					clearTimeout(refreshStatus)	
				} else {
					clearTimeout(refreshStatus)	
				}


				
				// if (resp.data.data.trip.timeExpired > 0) {
				// 	var countDownDate = resp.data.data.trip.timeExpired;

				// 	// Update the count down every 1 second
				// 	var x = setInterval(() => {

				// 		// Get todays date and time
				// 		var timeRemain = getCountDownTime(countDownDate);

				// 		// Display the result in the element with id="demo"
				// 		this.setState({
				// 			countdown: convertToDateTimeText(timeRemain)
				// 		})

				// 		// If the count down is finished, write some text 
				// 		if (timeRemain < 0) {
				// 			clearInterval(x);
				// 			this.setState({
				// 				countdown: convertToDateTimeText(timeRemain)
				// 			})
				// 		}
				// 	}, 1000);
				// } else {
				// 	this.setState({
				// 		countdown: ""
				// 	})
				// }
						const order = resp.data.data.order
						
						if (order.serviceType === 2) {
							let locationArray = []
							let { routes } = order.wd.routing
							for (let i = 0; i < routes.length; i++) {
								locationArray.push({ lat: routes[i].lat, lng: routes[i].lon })
							}
							setTimeout(() => {
								initMap(false, this.map, locationArray, undefined, '');
							}, 100)
						}

					} else {
						this.setState({
							err: resp.data.error,
							errMsg: resp.data.errorMessage
						});
					}
			});
	}



	// initMap(refs, locAddress) {

	// 	var directionsService = new window.google.maps.DirectionsService;
	// 	var directionsRenderer = new window.google.maps.DirectionsRenderer({
	// 		polylineOptions: {
	// 			strokeColor: "#00a550",
	// 			strokeWeight: 3
	// 		},
	// 		suppressMarkers: true,
	// 	});
	// 	const map = this.map = new window.google.maps.Map(refs.map, {
	// 		center: {
	// 			lat: 10.8,
	// 			lng: 106.660172
	// 		},
	// 		zoom: 13,
	// 		mapTypeControl: false,
	// 		scrollwheel: false,
	// 		clickableIcons: false,
	// 		streetViewControl: false,
	// 		zoomControl: true,
	// 		zoomControlOptions: {
	// 			position: window.google.maps.ControlPosition.RIGHT_BOTTOM
	// 		}
	// 	})
	// 	directionsRenderer.setMap(map);
	// 	this.calculateAndDisplayRoute(directionsService, directionsRenderer, locAddress, map)
	// 	this.setState({
	// 		directionsRenderer: directionsRenderer,
	// 		directionsService: directionsService,
	// 		map: map
	// 	})
	// }

	// calculateAndDisplayRoute(directionsService, directionsRenderer, locAddress, map) {

	// 	var markerArr = this.state.markerArr;
	// 	if (markerArr.length > 0) {
	// 		for (var j = 0; j < markerArr.length; j++) {
	// 			markerArr[j].setMap(null);
	// 		}
	// 		this.setState({
	// 			markerArr: []
	// 		})
	// 	}
	// 	var waypts = [];
	// 	for (let i = 1; i < locAddress.length - 1; i++) {
	// 		waypts.push({
	// 			location: locAddress[i],
	// 			stopover: true
	// 		});
	// 	}
	// 	directionsService.route({
	// 		origin: locAddress[0],
	// 		destination: locAddress[locAddress.length - 1],
	// 		waypoints: waypts,
	// 		optimizeWaypoints: true,
	// 		travelMode: 'DRIVING'
	// 	}, (response, status) => {
	// 		if (status === 'OK') {
	// 			directionsRenderer.setDirections(response);

	// 			var _legs = response.routes[0].legs;
			
	// 			for (let i = 0; i < _legs.length; i++) {
	// 				if (i == 0) {
	// 					if (_legs[i].start_address === _legs[i].end_address) {
	// 						this.pA = this.createMarker(_legs[i].start_location, map, i);
	// 					} else {
	// 						this.pA = this.createMarker(_legs[i].start_location, map, i);
	// 						this.pEnd = this.createMarker(_legs[i].end_location, map, _legs.length);
	// 					}
	// 				} else {
	// 					this.pA += this.createMarker(_legs[i].start_location, map, i);
	// 					this.pEnd = this.createMarker(_legs[_legs.length - 1].end_location, map, _legs.length)
	// 				}
	// 			}
	// 		}
	// 	})
	// }

	// getMarkerImage(index) {
	// 	var pins = [marker_0, marker_1, marker_2, marker_3, marker_4]
	// 	var icon = {
	// 		url: pins[index],
	// 		size: new window.google.maps.Size(40, 50),
	// 		origin: new window.google.maps.Point(0, 0),
	// 		anchor: new window.google.maps.Point(17, 34),
	// 		scaledSize: new window.google.maps.Size(34, 44)
	// 	};
	// 	return icon
	// }

	// createMarker(latlng, map, index) {
	// 	var markerArr = this.state.markerArr
	// 	var marker = new window.google.maps.Marker({
	// 		position: latlng,
	// 		map: map,
	// 		icon: this.getMarkerImage(index),
	// 		title: this.state.order.wd.routing.routes[index].addr
	// 	});
	// 	var contentString = `<div>${this.state.order.wd.routing.routes[index].addr}</div>`;
	// 	var infowindow = new window.google.maps.InfoWindow({
	// 		content: contentString
	// 	});
	// 	marker.addListener('click', function () {
	// 		infowindow.open(map, marker);
	// 	});
	// 	markerArr.push(marker)
	// 	this.setState({
	// 		markerArr: markerArr
	// 	})
	// 	return marker
	// }


	showLoginForm() {
		this.setState({
			showLoginForm: true
		});
	}

	openLoginForm() {
		this.setState({
			showLoginForm: true
		});
	}

	closeLoginForm() {
		this.setState({
			showLoginForm: false
		});
	}

	cancelTrip() {
		this.showCancelForm();
	}

	showCancelForm() {
		this.setState({
			showCancelForm: true
		});
	}

	closeCancelForm() {
		this.setState({
			showCancelForm: false
		});
	}

	showApproveForm() {
		this.setState({
			showApproveForm: true
		});
	}

	closeApproveForm() {
		this.setState({
			showApproveForm: false
		});
	}

	showRejectForm() {
		this.setState({
			showRejectForm: true
		});
	}

	closeRejectForm() {
		this.setState({
			showRejectForm: false
		});
	}

	showPickupForm() {
		this.setState({
			showPickupForm: true
		});
	}

	closePickupForm() {
		this.setState({
			showPickupForm: false
		});
	}

	showReturnForm() {
		this.setState({
			showReturnForm: true
		});
	}

	closeReturnForm() {
		this.setState({
			showReturnForm: false
		});
	}

	showCancelOwnerForm() {
		this.setState({
			showCancelOwnerForm: true
		});
	}

	closeCancelOwnerForm() {
		this.setState({
			showCancelOwnerForm: false
		});
	}

	showTravelerReviewForm() {
		this.setState({
			isShowTravelerReviewForm: true
		});
	}

	closeTravelerReviewForm() {
		this.setState({
			isShowTravelerReviewForm: false
		});
	}

	// showTripPhoto() {
	// 	this.setState({
	// 		showTripPhoto: true
	// 	});
	// }

	// closeTripPhoto() {
	// 	this.setState({
	// 		showTripPhoto: false
	// 	});
	// 	const tripId = this.props.match.params.tripId;
	// 	this.getTrip(tripId);
	// 	// this.showActiveInsMsg()
	// }
	// showInsuranceForm(tripId, certNo) {
	// 	this.setState({
	// 		showInsuranceForm: true
	// 	});
	// 	this.getActiveInsurance(tripId, certNo)
	// }

	// closeInsuranceForm() {
	// 	this.setState({
	// 		showInsuranceForm: false
	// 	})
	// }

	// travelerReview() {
	// 	this.showTravelerReviewForm();
	// }

	getLoggedProfile() {
		this.props.dispatch(getLoggedProfile());
	}

	// onCertDetailBtn(certInfo) {
	// 	if (certInfo.certUrl) {
	// 		window.open(certInfo.certUrl, '_blank');
	// 	} else {
	// 		this.setState({
	// 			showMsgCert: true
	// 		})
	// 	}
	// }
	// showMsgCert() {
	// 	this.setState({
	// 		showMsgCert: true
	// 	})
	// }
	// closeMsgCert() {
	// 	this.setState({
	// 		showMsgCert: false
	// 	})
	// }



	buildTravelerTripStatusBar(trip) {
		switch (trip.status) {
			case -740: 
				return <div className="content-register d-shadow">
					<div className="stepbystep">
						<ul>
							<li><span className="nu">1</span><span className="value">Tìm xe</span></li>
							<li><span className="nu">3</span><span className="value">Khởi hành</span></li>
							<li><span className="nu">3</span><span className="value">Kết thúc</span></li>
						</ul>
					</div>
					<div className="booking-status status-trips reject-trip">
						<p><span className="status black-dot"></span><span>Không tìm được xe phù hợp</span></p>
					</div>
				</div>
			case -1: 
				return <div className="content-register d-shadow">
								<div className="stepbystep">
									<ul>
										<li className="next-step"><span className="nu">1</span><span className="value">Tìm xe</span></li>
										<li><span className="nu">2</span><span className="value">Tìm xe</span></li>
										<li><span className="nu">3</span><span className="value">Khởi hành</span></li>
									</ul>
								</div>
							
							<div className="booking-status status-trips arrow-1">
								<p><span className="status orange-dot"> </span><span>Bạn cần thanh toán cọc.</span></p>
								{/* {this.state.countdown && this.state.countdown !== "" && <span className="countdown">{this.state.countdown}</span>} */}
							</div>
						</div>
			
			case 102: 
				return 	<div className="content-register d-shadow">
						<div className="stepbystep">
							<ul>
								<li className="next-step"><span className="nu">1</span><span className="value">Tìm xe</span></li>
								<li><span className="nu">2</span><span className="value">Khởi hành</span></li>
								<li><span className="nu">3</span><span className="value">Kết thúc</span></li>
							</ul>
						</div>
					
					<div className="booking-status status-trips arrow-1">
						<div className="d-flex">
							<div className="multi-ripple">
								<div></div>
								<div></div>
							</div>
							<p>Hệ thống đang tìm xe</p>
						</div>
						{/* {this.state.countdown && this.state.countdown !== "" && <span className="countdown">{this.state.countdown}</span>} */}
					</div>
				</div>
		
			case 4: 
			case 200: 
				return 	<div className="content-register d-shadow">
							<div className="stepbystep">
								<ul>
									<li className="active"><span className="nu">1</span><span className="value">Tìm xe</span></li>
									<li className="next-step" ><span className="nu">2</span><span className="value">Khởi hành</span></li>
									<li><span className="nu">3</span><span className="value">Kết thúc</span></li>
								</ul>
							</div>
		
						<div className="booking-status status-trips arrow-2">
							<p><span className="status green-dot"></span><span>Đã tìm được xe. Chuyến thuê sẽ bắt đầu vào {moment(trip.tripDateFrom).format('HH:mm ngày DD/MM/YYYY')} </span></p>
							{/* {this.state.countdown && this.state.countdown !== "" && <span className="countdown">{this.state.countdown}</span>} */}
						</div>
					</div>
		

			case 5: 
				return <div className="content-register d-shadow">
						<div className="stepbystep">
							<ul>
								<li className="active"><span className="nu">1</span><span className="value">Tìm xe</span></li>
								<li className="active" ><span className="nu">2</span><span className="value">Khởi hành</span></li>
								<li className="next-step"><span className="nu">3</span><span className="value"></span>Kết thúc</li>
							</ul>
						</div>
				
					<div className="booking-status status-trips arrow-3">
						<p><span className="status green-dot"></span><span>Chuyến thuê sẽ kết thúc vào {moment(trip.tripDateTo).format('HH:mm ngày DD/MM/YYYY')} </span></p>
						{/* {this.state.countdown && this.state.countdown !== "" && <span className="countdown">{this.state.countdown}</span>} */}
					</div>
				</div>

			
			case 23:
			case 24: 
				return 	<div className="content-register d-shadow">
					<div className="stepbystep">
						<ul>
							<li><span className="nu">1</span><span className="value">Tìm xe</span></li>
							<li><span className="nu">2</span><span className="value">Khởi hành</span></li>
							<li><span className="nu">3</span><span className="value">Kết thúc</span></li>
						</ul>
					</div>
		
				<div className="booking-status status-trips reject-trip">
					<p><span className="status red-dot"></span><span>Chuyến đã bị hủy</span></p>
					{/* {this.state.countdown && this.state.countdown !== "" && <span className="countdown">{this.state.countdown}</span>} */}
				</div>
			</div>

			case 25: 
				return 	<div className="content-register d-shadow">
						<div className="stepbystep">
							<ul>
								<li className="active"><span className="nu">1</span><span className="value">Thanh toán cọc</span></li>
								<li className="active"><span className="nu">2</span><span className="value">Tìm xe</span></li>
								<li className="active"><span className="nu">3</span><span className="value">Khởi hành</span></li>
							</ul>
						</div>
					
						<div className="booking-status status-trips arrow-4">
							<p><span className="status black-dot"></span><span>Chuyến đã kết thúc</span></p>
							{/* {this.state.countdown && this.state.countdown !== "" && <span className="countdown">{this.state.countdown}</span>} */}
						</div>
					</div>
		
			
		}
	}


	render() {
		var content;
		var contentCertIns; 
		const profile = this.props.session.profile;
		const { err } = this.state;
		const platformType = this.props.appInit;


		if (err === commonErr.INNIT || err === commonErr.LOADING) {
			content = <LoadingPage />
		} else if (profile.err !== commonErr.INNIT && profile.err !== commonErr.LOADING && (!profile.info || !profile.info.uid)) {
			content = <Redirect to="/" />
		} else if (err >= commonErr.SUCCESS) {

			const { carGroup, order, trip, travelerInfo, f1Info, showCancelForm} = this.state;
			let isSeflDrive= order.serviceType === 1;
			let isWithDriver = order.serviceType === 2;

			const ownerProfile = trip !== null && trip ? trip.ownerProfile : null;

			if (order) {
		
				let statusBar = this.buildTravelerTripStatusBar(order);
				
				var btnTrip;
				
				if ((order.status < 20 || order.status >= 102) && order.status >= -1) {
					btnTrip = <div className="wrap-btn dt-trip-btn text-center">
						<div className="wr-btn"><button className="btn btn-danger" onClick={this.cancelTrip.bind(this)}>Huỷ chuyến</button></div>
						<CancelTrip uid={profile.info.uid} getOrder={this.getOrder} order={order} show={showCancelForm} hideModal={this.closeCancelForm.bind(this)} />
					</div>
				// } else if (order.status <= 2) {
				// 	rơ = <div className="wrap-btn dt-trip-btn has-2btn text-center">
				// 		<div className="wr-btn"><a className="btn btn-danger" onClick={this.cancelTrip.bind(this)}>Huỷ chuyến</a></div>
				// 		{/* <PaymentBtn tripId={trip.id} /> */}
				// 		{/* <div className="wr-btn">
				// 			<a className="btn btn-primary btn--m" href={`/payment/${trip.id}?deposit=${trip.priceSummary.deposit}&timeExpired=${trip.timeExpired}`}>Thanh toán</a>
				// 		</div> */}
				// 		<CancelTrip getOrder={this.getOrder} order={order} show={this.state.showCancelForm} hideModal={this.closeCancelForm.bind(this)} />
				// 	</div>
				// } else if (order.status < 4) {
				// 	btnTrip = <div className="wrap-btn dt-trip-btn text-center" >
				// 		<div className="wr-btn"><a className="btn btn-danger" onClick={this.cancelTrip.bind(this)}>Huỷ chuyến</a></div>
				// 		<CancelTrip getOrder={this.getOrder} order={order} show={this.state.showCancelForm} hideModal={this.closeCancelForm.bind(this)} />
				// 	</div>
			
				} else //if (trip.needReview === 1) 
					{	btnTrip = <div className="wrap-btn dt-trip-btn text-center">
						{/* <div className="wr-btn"><a className="btn btn-primary btn--m" onClick={this.travelerReview.bind(this)}>Đánh giá chuyến</a></div> */}
						{/* <ReviewTripTraveler getTrip={this.getTrip} trip={trip} show={this.state.isShowTravelerReviewForm} hideModal={this.closeTravelerReviewForm.bind(this)} /> */}
					</div>
				}
		
				var subContent = <div className="trip-detail__sect">
				<div className="ibox status-wrapper">
					{statusBar}
				</div>
				
			<div className="ibox">
			<div className="content-trip ibox-body">
				<div className="content-booking">
					<div className="info-trip--more row">
						<div className="group-1 col-md-4 col-sm-12">
							<div className="car-img mb-4">
								<div className="fix-img" style={{paddingBottom: "75%"}}><img src={carGroup ? carGroup.avatarUrl : ""} alt={`Cho thuê xe ô tô`} /></div>
								</div>
								<p>Các dòng xe: {carGroup.groupDesc}</p>	
						</div>
						<div className="group-2 col-md-8 col-12">
							<div className="group-info">
								<h5 className="name text-uppercase mb-3">{carGroup.groupName}</h5>
							
								<h6>Thời gian thuê xe</h6>
								<div className="form-default grid-form">
									<div className="line-form has-timer">
										<p>Bắt đầu: {moment(order.tripDateFrom).format("DD/MM/YYYY HH:mm")}</p>
									</div>
									<div className="line-form has-timer">
										<p>Kết thúc: {moment(order.tripDateTo).format("DD/MM/YYYY HH:mm")}</p>
									</div>
								</div>
							</div>

							{isWithDriver && <div className="group-info">
									<h6>Lộ trình: <span>{WDTypes[order.wd.wdType]}</span></h6>
									<div className="">
										<p>{order.wd.routing.routes[0].addr}</p>
										{order.wd.routing.routes.map((address, index) => {
											if(index === 0) return null
											return <p key={index}>{address.addr}</p>})}
									</div>
									
									<div className="map-route mb-4">
										<div ref={this.map} style={{ width: '100%', height: '300px', background: 'grey' }}></div>
									</div>

									<h6>Thông tin lộ trình</h6>
									{order.wd.routing.distanceInKM > 0 && <p>Tổng lộ trình: {order.wd.routing.distanceInKM.toFixed(1)} km</p>}
									{order.limitKM > 0 && <p>Số km được đi: {order.limitKM} km</p>}	
									<p>Phí phụ thu vượt km: 6k/nghìn</p>
									<p>Phí phụ thu vượt giờ: 60k/giờ</p>	
											
								</div>}
								{trip !== null && ownerProfile && <div className="group-info">
										<h6>Chủ xe</h6>
										<div className="desc-profile d-flex">
											
											<div className="avatar-img">
												<img src={`${(ownerProfile.avatar && ownerProfile.avatar.thumbUrl) ? ownerProfile.avatar.thumbUrl : ""}`} className="rounded-circle img-fluid"/>
											</div>
										  
											<div className="info-profile">
												<h6> {ownerProfile.name}</h6>
												<StarRatings
														rating={ownerProfile.owner.rating.avg}
														starRatedColor="#00a550"
														starDimension="17px"
														starSpacing="1px"
											/>
											<div className="mb-2" />
											<h6>Số điện thoại</h6>
											{order.status >= 4 && <p>{ownerProfile.phoneNumber || '***********'}</p>}
											{order.status < 4 && <p>***********</p>}
											{order.status < 4 && <p>Số điện thoại liên hệ sẽ được hiển thị sau khi đặt cọc.</p>}
										</div>
									</div>	
								</div>	}
					 
								{isSeflDrive && <div className="group-4 ">
									 <div className="group-info">
												<h6>Giới hạn số km</h6>
												<p>Tối đa <span className="font-strong">300km/ngày</span> - Phí vượt giới hạn: <span className="font-strong">5km/ngày</span>. Phí thu vượt giờ: <span className="font-strong">100k/giờ</span></p>
										</div>
								</div> }
								{isSeflDrive && <div className="group-tphoto">
									<div className="group-info required-paper">
										<h6>Giấy tờ thuê xe (bản gốc)</h6>
										{travelerInfo && travelerInfo.cmnd_gplx === 1 && <li>CMND và GPLX (đối chiếu)</li>}
										{/* {travelerInfo && travelerInfo.hk === 1 && <li>Sổ hộ khẩu</li>}
										{travelerInfo && travelerInfo.hk_kt3 === 1 && <li>KT3</li>} */}
										{travelerInfo && travelerInfo.pp === 1 && <li>Passport (giữ lại)</li>}
										{travelerInfo && travelerInfo.cccd_all === 1 && <li>CCCD gắn chip (đối chiếu)</li>}
										{travelerInfo.cmnd_gplx === 0 && travelerInfo.hk === 0 && travelerInfo.hk_kt3 === 0 && travelerInfo.pp === 0 && <li>Không có giấy tờ</li>}
									</div>
									{travelerInfo.others && travelerInfo.others !== "" && <div className="group-info required-paper">
										<h6>Giấy tờ khác</h6>
										<p>{travelerInfo.others}</p>
									</div>}
								</div>}
							</div>
						</div>
								
						<div className="row mb-4">
							<div className="col-md-4"></div>
								<div className="col-md-8">
									{f1Info !== null && f1Info && <div className="group-info">
										<h6>Chuyến được đặt bởi</h6>
										<div className="desc-profile d-flex">
											
											<div className="avatar-img">
												<img src={`${(f1Info.avatar && f1Info.avatar.thumbUrl) ? f1Info.avatar.thumbUrl : ""}`} className="rounded-circle img-fluid"/>
											</div>
										  
											<div className="info-profile">
												<h6>ĐẠI LÝ</h6>	
												<h6> {f1Info.name}</h6>
												<StarRatings
														rating={f1Info.traveler.rating.avg}
														starRatedColor="#00a550"
														starDimension="17px"
														starSpacing="1px"
											/>
										</div>
									</div>	
								</div>	}
								{travelerInfo && <div className="group-info">
									{platformType === TPlatformType.BIZ && order.miAppId < 0 ? <h6>Thông tin nhân viên</h6> : <h6>Thông tin</h6>}
									{platformType === TPlatformType.AGENT ? <h6>Thông tin khách thuê</h6> : null}
									<p>Họ tên: {travelerInfo.travelerName}</p>								
									<p>Số điện thoại: +{travelerInfo.travelerPhone}</p>		
									{order.miAppId >= 0 ? <p>Platform: {MiAppType[order.miAppId]}</p> : null}
									{travelerInfo.travelerEmail && travelerInfo.travelerEmail !== "" && <p> Email: {travelerInfo.travelerEmail} </p>}								
								</div>}
								<div className="group-info">
									<h6>Thanh toán</h6> 
									<div className="payment-box">
										<p className="d-flex">Tổng chuyến: <NumberFormat value={order.price} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></p>
										<p className="d-flex">Đặt cọc: <NumberFormat value={order.deposit} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></p>
										<p className="d-flex">Thanh toán cho chủ xe: <NumberFormat value={order.price - order.deposit} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></p>
									</div>		
								</div>

						
								{(order.status <= 4 || order.status >= 20) && <div className="group-info">
									<h6>Chính sách hủy chuyến</h6>
									<table className="table table-bordered">
										<thead className="thead-default">
											<tr>
												<th>Thời điểm hủy chuyến</th>
												<th>Phí hủy chuyến</th>
												<th>Số tiền cọc hoàn trả</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>Trong vòng 1 giờ sau khi đặt cọc</td>
												<td>0% Giá trị chuyến đi</td>
												<td>100% Giá trị chuyến đi</td>
											</tr>
											<tr>
												<td>&gt; 7 ngày trước khởi hành</td>
												<td>10% Giá trị chuyến đi</td>
												<td>90% Giá trị chuyến đi</td>
											</tr>
											<tr>
												<td>&lt;= 7 ngày trước khởi hành</td>
												<td>30% Giá trị chuyến đi</td>
												<td>70% Giá trị chuyến đi</td>
											</tr>
										</tbody>
									</table>
									<p className="text-danger font-13">*** Tiền cọc sẽ được hoàn trả trong vòng 1 - 3 ngày làm việc</p>
									
								</div>}
						</div>
					</div>
				</div>
				{btnTrip}
				</div>
			</div>
					<StatusTripBox show={this.state.showStatusTrip} status={this.state.status} />
		</div>


		
		content = <div className="mioto-layout page-wrapper">
			<Header />
			<Sidebar />
			<div className="content-wrapper">
				<div className="page-content fade-in-up">
					
					{subContent}
				
				</div>
			<Footer />
			</div>
		</div>
			
			} else {
				content = <Redirect to="/notfound" />
			}
		} else {
			content = <Redirect to="/notfound" />
		}

		return (content);
	}
}

function mapSession(state) {
	return {
		session: state.session, 
		appInit: state.appInit,
	}
}

TripDetail = connect(mapSession)(TripDetail);

export default TripDetail;


// WEBPACK FOOTER //
// ./src/components/trip/tripdetail.js